import React from "react";
import { motion } from "framer-motion";
import {
    Mail,
    Phone,
    MapPin,
    Clock,
} from "lucide-react";
import ContactForm from "../frontend/ContactForm";

const Contact = () => {


    return (
        <section id="contact" className="w-full py-24 px-4 sm:px-10 lg:px-20 2 font-poppins relative overflow-hidden">
            {/* Background Decor */}
            <div className="relative z-10 max-w-7xl mx-auto">

                {/* HEADER */}
                <div className="lg:text-center mb-16 space-y-4">
                    <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                        className="inline-flex items-center gap-2 px-3 py-1 mb-6 rounded-full bg-primary/10 border border-primary/20 backdrop-blur-sm"
                    >
                        <span className="w-1.5 h-1.5 rounded-full bg-primary animate-pulse"></span>
                        <span className="text-xs font-bold tracking-widest text-primary uppercase">
                               Contact Us
                        </span>
                    </motion.div>
                    <motion.h2
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.1 }}
                        className="text-3xl sm:text-5xl lg:text-6xl font-bold text-dark dark:text-light leading-[1.1]"
                    >
                        Let’s start a conversation
                    </motion.h2>
                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.2 }}
                        className="text-lg text-slate-600 dark:text-slate-400 max-w-2xl mx-auto"
                    >
                        Have a question about our services?
                        Fill out the form and our team will get back to you within 24 hours.
                    </motion.p>
                </div>

                {/* CONTENT GRID */}
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-8 items-start">

                    {/* LEFT SIDE: Contact Info */}
                    <motion.div
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                        className="lg:col-span-5 space-y-8 lg:pr-8"
                    >
                        <div className="bg-white dark:bg-slate-900/50 backdrop-blur-sm p-8 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-sm">
                            <h3 className="text-2xl font-bold text-primary dark:text-white mb-6">Contact Information</h3>
                            <div className="space-y-6">
                                <ContactInfo icon={<MapPin size={28}/>} title="Address" text="Building A1, Dubai Digital Park, Dubai Silicon Oasis, Dubai, United Arab Emirates" url="https://maps.app.goo.gl/fV4FWuGxbWV85bodA"/>
                                <ContactInfo
                                    icon={<Mail size={28} />}
                                    title="Email"
                                    text="info@fortunesignals.ae"
                                    url="mailto:info@fortunesignals.ae"
                                />
                                <ContactInfo icon={<Phone size={28}/>} title="BHAGESH GIRI" text="+971 50 369 9864" url="tel:+971503699864"/>
                                <ContactInfo icon={<Phone size={28}/>} title="VINAYAK JOSHI" text="+971 50 257 6323" url="tel:+971502576323"/>
                                <ContactInfo icon={<Clock size={28}/>} title="Working Hours" text="Mon – Sat: 9:00 AM – 7:00 PM"/>
                            </div>
                        </div>

                        {/*<div className="bg-blue-600 dark:bg-blue-600 rounded-2xl p-8 text-white relative overflow-hidden">*/}
                        {/*    <div className="relative z-10">*/}
                        {/*        <Globe className="w-10 h-10 mb-4 opacity-80" />*/}
                        {/*        <h4 className="text-xl font-bold mb-2">Global Support</h4>*/}
                        {/*        <p className="opacity-90 leading-relaxed">*/}
                        {/*            We support clients in over 30 countries. Our team is distributed globally to ensure timely responses regardless of your time zone.*/}
                        {/*        </p>*/}
                        {/*    </div>*/}
                        {/*    /!* Decorative circles *!/*/}
                        {/*    <div className="absolute -bottom-10 -right-10 w-40 h-40 bg-white/10 rounded-full blur-2xl" />*/}
                        {/*    <div className="absolute top-10 -right-10 w-20 h-20 bg-white/10 rounded-full blur-xl" />*/}
                        {/*</div>*/}
                    </motion.div>

                    {/* RIGHT SIDE: Form */}
                    <ContactForm />

                </div>
            </div>
        </section>
    );
};

export default Contact;


/* ---------------------- INFO BOX COMPONENT ----------------------- */
function ContactInfo({ icon, title, text, url }) {
    const content = (
        <div className="flex items-center gap-4 group cursor-default">
            <div className="
                    flex-shrink-0 w-12 h-12 rounded-xl
                    bg-blue-50 dark:bg-blue-900/20
                    flex items-center justify-center
                    text-blue-600 dark:text-blue-400
                    group-hover:scale-110 transition-transform duration-300
                  ">
                {icon}
            </div>
            <div>
                <p className="text-sm font-medium text-slate-500 dark:text-slate-400 mb-0.5">{title}</p>
                <h4 className="text-base font-semibold text-slate-800 dark:text-slate-200 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors">
                    {text}
                </h4>
            </div>
        </div>
    );

    return url ? (
        <a href={url} target="_blank" rel="noreferrer" className="block">
            {content}
        </a>
    ) : (
        content
    );
}


